/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lockedat1Inputs */

const en__field_lockedat1 = /** @type {(inputs: _Field_Lockedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locked at`)
};

/**
* | output |
* | --- |
* | "Locked at" |
*
* @param {_Field_Lockedat1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_lockedat1 = /** @type {((inputs?: _Field_Lockedat1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lockedat1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_lockedat1(inputs)
});
export { _field_lockedat1 as "_field_lockedAt" }